





































import { defineComponent } from "@vue/composition-api";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import FormatMoney from "@/components/FormatMoney";

export default defineComponent({
  name: "SubscriptionConfirmModal",
  components: { FormatMoney, BaseButton, BaseConfirm },
  props: {
    selectedSubscriptionLevel: { type: Object as () => SubscriptionLevel | null },
    cost: { type: Number },
    currentAmount: { type: Number },
    mainCurrency: { type: String, required: true },
    paymentSystemId: { type: String, required: true },
  },
  data() {
    return {
      showUpgradeSubscriptionModal: false,
    };
  },
  methods: {
    subscribe() {
      this.showUpgradeSubscriptionModal = false;
      this.$emit("subscribe", this.selectedSubscriptionLevel);
    },
    cancelUpgradeLevel() {
      this.showUpgradeSubscriptionModal = false;
      this.$emit("cancelUpgradeLevel");
    },
  },
  async mounted() {
    if (this.currentAmount !== this.cost) {
      this.showUpgradeSubscriptionModal = true;
    } else {
      await this.subscribe();
    }
  },
});
